import { render, staticRenderFns } from "./NewCuentasbancarias.vue?vue&type=template&id=124410d8&scoped=true&"
import script from "./NewCuentasbancarias.vue?vue&type=script&lang=ts&"
export * from "./NewCuentasbancarias.vue?vue&type=script&lang=ts&"
import style0 from "./NewCuentasbancarias.vue?vue&type=style&index=0&id=124410d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124410d8",
  null
  
)

export default component.exports